import React from 'react';
import * as S from './BurgerNav.styles';
import { BurgerNavDrawer } from './BurgerNavDrawer';
import { useBodyOverflow } from '@/hooks/useBodyOverflow';
import { Portal } from '@/components/UI/Portal/Portal';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { useNavMenuStore } from '@/store/useNavMenuStore';

export const BurgerNav = () => {
  const [isNavOpen, toggleNav] = useNavMenuStore(state => [
    state.isNavOpen,
    state.toggleNav,
  ]);
  useBodyOverflow(isNavOpen);

  return (
    <Portal>
      <S.BurgerNavOverlay
        data-testid={CommonTestIds.navMenu.overlay}
        isOpen={isNavOpen}
        onClick={toggleNav}
      />
      <BurgerNavDrawer isOpen={isNavOpen} toggleNav={toggleNav} />
    </Portal>
  );
};
